import styled from "styled-components";
import { Device } from "../../../styles/screenSizes";

export const StyledBranding = styled.div`
  display: flex;
  flex-direction: column;

  @media ${Device.notLaptop} {
    padding-top: 80px;
  }
`;

export const StyledBrandLogoImg = styled.div`
  display: flex;
  justify-content: flex-start;
  position: relative;

  /*
    the below styles here and on the img
    should allow all images to fit within
    the container correctly
  */
  width: 160px;
  height: 50px;
  object-fit: contain;
  object-position: left;

  img {
    object-fit: contain;
    width: 160px;
    height: 50px;
    object-position: left;
    /* for IE 11; see https://stackoverflow.com/a/43227016 */
    flex: 1;
  }
`;

export const StyledSocialMediaIcons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 1rem;
`;

export const StyledBrandLogo = styled.span`
  padding-right: 0.9rem;

  svg {
    width: 1.1rem;
    height: 1.1rem;
    object-fit: contain;
    object-position: left;
    path {
      fill: ${({ theme }) => theme.footer?.textColor || "#fff"};
    }
  }
`;

export const StyledPhoneAndAddress = styled.div`
  padding-top: 11px;
  white-space: nowrap;

  p {
    margin: 0;
    font-size: 12px;
  }
`;
